const SPURS = [
  'NavalX',
  'Marine Innovation Unit',
  'Army Futures Command',
  'Kessel Run',
  'Multiple Program Offices',
]

export default function Team() {
  return (
    <section id="team" className="lp-sec lp-sec--lift">
      <div className="lp-wrap lp-two">
        <div style={{ minWidth: 0 }}>
          <h2 className="lp-team__h2">
            <span>Built with the people who buy.</span>
            <span>By people who&rsquo;ve done the work.</span>
          </h2>
          <p className="lp-lede">
            We design with real DoW users, on real acquisition programs, under
            active agreements. We&rsquo;re building the tool we wish we&rsquo;d
            had while we were in their seats.
          </p>
        </div>

        <div className="lp-spurs">
          <div className="lp-spurs__label">OUR TEAM EARNED THEIR SPURS AT</div>
          {SPURS.map((s) => (
            <div key={s} className="lp-spurs__row">{s}</div>
          ))}
        </div>
      </div>
    </section>
  )
}
